exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".label-info {\n    margin: 0px !important;\n    padding: 0px !important;\n    margin-top: -5px !important;\n}\n\n.spinner-pos {\n    margin-right: 0px !important;\n    top: 2px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/new-user-form/new-user-form.component.css
// module id = 836
// module chunks = 0